var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "key-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.9667 8.33249C14.9667 7.90597 14.804 7.47946 14.4786 7.15403C14.1531 6.82859 13.7266 6.66588 13.3 6.66588M13.3 13.3325C16.0615 13.3325 18.3 11.094 18.3 8.33254C18.3 5.57112 16.0615 3.33254 13.3 3.33254C10.5386 3.33254 8.30005 5.57112 8.30005 8.33254C8.30005 8.56061 8.31532 8.78511 8.34489 9.00507C8.39353 9.36686 8.41785 9.54775 8.40148 9.6622C8.38443 9.78142 8.36272 9.84567 8.30396 9.95079C8.24755 10.0517 8.14814 10.1511 7.94933 10.3499L3.69057 14.6087C3.54645 14.7528 3.47438 14.8249 3.42285 14.909C3.37716 14.9835 3.34349 15.0648 3.32307 15.1498C3.30005 15.2458 3.30005 15.3477 3.30005 15.5515V16.9992C3.30005 17.4659 3.30005 17.6993 3.39088 17.8775C3.47077 18.0343 3.59826 18.1618 3.75506 18.2417C3.93332 18.3325 4.16667 18.3325 4.63338 18.3325H6.63338V16.6659H8.30005V14.9992H9.96672L11.2827 13.6833C11.4815 13.4845 11.5809 13.385 11.6818 13.3286C11.7869 13.2699 11.8512 13.2482 11.9704 13.2311C12.0848 13.2147 12.2657 13.2391 12.6275 13.2877C12.8475 13.3173 13.072 13.3325 13.3 13.3325Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.bce2dd7860a82e27695687f5d6a14801.svg";
export { ForwardRef as ReactComponent };